import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { useRequest } from 'features/request/useRequest';
import { usePageFilterSaver } from 'hooks/usePageFilterSaver';
import { gqlWorkOrderVorTypeAndStatusFollowers } from 'pages/Project/UerProject/WorkOrder/workOrderQueries';
import { WorkOrderUploadModal } from 'pages/Project/UerProject/WorkOrder/WorkOrderUpload';

import type React from 'react';
import { useCallback, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const ReplaceWorkOrder: React.FC = () => {
    const { orderChangeId } = useParams();
    const { state: prevRoute, pathname } = useLocation();
    const navigate = useNavigate();
    const [isContinueDialogOpen, setIsContinueDialogOpen] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { handleCleanEntityMemoizedValues } = usePageFilterSaver();

    const variables = useMemo(() => ({ workOrderId: Number(orderChangeId) }), [orderChangeId]);

    const [workOrderVorTypeResponse] = useRequest({
        requestId: 'workOrderVorType',
        query: gqlWorkOrderVorTypeAndStatusFollowers,
        variables,
    });

    const onContinue = useCallback(() => {
        setIsContinueDialogOpen(false);
        setIsModalOpen(true);
    }, []);

    const onUploadModalClose = useCallback(() => {
        if (isModalOpen) {
            setIsModalOpen(false);

            if (prevRoute) {
                navigate(prevRoute);
            }
        }
    }, [isModalOpen, navigate, prevRoute]);

    const onConfirmationClose = useCallback(
        (isConfirmed: boolean) => {
            setIsContinueDialogOpen(false);

            if (!isConfirmed) {
                navigate(prevRoute);
            }
        },
        [navigate, prevRoute],
    );

    const onSuccessReplace = useCallback(() => {
        const memoWorkOrderKey = pathname.replace('/replace', '');

        handleCleanEntityMemoizedValues({
            pathNameKey: memoWorkOrderKey,
        });
    }, [handleCleanEntityMemoizedValues, pathname]);

    return (
        <>
            {isModalOpen && orderChangeId && (
                <WorkOrderUploadModal
                    workOrderId={Number(orderChangeId)}
                    onClose={onUploadModalClose}
                    vorType={workOrderVorTypeResponse?.uerWorkOrder?.data?.vorType}
                    onSuccess={onSuccessReplace}
                    isReplace
                />
            )}
            <ConfirmationDialog
                textHeader="Замена файла ВОР"
                textConfirmation="При загрузке нового файла все введённые данные в Наряд-Заказе будут удалены"
                cancelButtonText="Отменить"
                confirmButtonText="Продолжить"
                isOpened={isContinueDialogOpen}
                onSubmit={onContinue}
                onClose={onConfirmationClose}
            />
        </>
    );
};

ReplaceWorkOrder.displayName = 'ReplaceWorkOrder';
